import { InvalidItem } from "./GeoModelJob";

/// Frequency options for scheduled calculation jobs
export enum ScheduleFrequency {
  /// Run job once per week
  Weekly = "Weekly",
  /// Run job once per month
  Monthly = "Monthly"
}

export interface GeoCalculationsJob {
  jobId: string;
  name: string;
  leftWidth: number;
  rightWidth: number;
  upHeight: number;
  downHeight: number;
  savedFilterId?: string;
  savedFilterName?: string;
  savedFilterJson?: string;
  wellList?: string[];
  email: string;
  // Server-reported status on the jobs list (e.g. "Queued", "40/128", "Completed").
  // Used to seed the pill immediately so it doesn't flash "Checking…" before the
  // first live status poll returns.
  status?: string;
  lastSuccessfulRunDate?: { $date?: { $numberLong?: string } };
  formattedLastSuccessfulRunDate?: string;
  runId?: string;
  zones: string[];
  modelSource?: string;
  primarySource?: string;
  // Plays the creator held a geo module for, stamped by the scheduler at creation.
  plays?: string[];
  includeSampled3D?: boolean;
  includeXda?: boolean;
  createdBy?: string;
  errorMessage?: string;
  invalidItems?: InvalidItem[];

  // Scheduling fields
  isScheduled?: boolean;
  scheduleFrequency?: ScheduleFrequency | null;
  scheduleStartDate?: { $date?: { $numberLong?: string } } | number | string | null;
  nextScheduledRun?: { $date?: { $numberLong?: string } } | number | string | null;
  lastScheduledRun?: { $date?: { $numberLong?: string } } | number | string | null;
}
